import { TileLayer } from "react-leaflet";

/* Base map tiles for every map in the app (Discover + Event Details mini-map).

   Dark mode: CARTO dark_all served through our own /api/tiles/dark proxy, which
   converts each tile to true greyscale in the pixels (support #279162). CARTO
   redesigned Dark Matter in 2026 (blue-slate roads, lighter water); RoadRnr
   launched with the near-black neutral grey look, so the proxy restores it with
   no CSS filter (iOS Safari applied those unevenly). Labels are part of the tile.
   The ?v= suffix busts tiles already cached on phones: bump it if the dark tile
   treatment ever changes.

   Light mode: CARTO Positron (light_all), unchanged. */

const CARTO_KEY = "cb1_25x8_1_84c611141f7cd540c6cbaa47";
const CARTO_LIGHT = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=${CARTO_KEY}`;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const DARK_TILES = `${BACKEND_URL}/api/tiles/dark/{z}/{x}/{y}.png?v=2`;

export function MapTiles({ theme }) {
  if (theme === "light") {
    return (
      <TileLayer
        key="light"
        url={CARTO_LIGHT}
        attribution="&copy; OpenStreetMap &copy; CARTO"
        subdomains="abcd"
        maxZoom={20}
      />
    );
  }
  return (
    <TileLayer
      key="dark"
      url={DARK_TILES}
      attribution="&copy; OpenStreetMap &copy; CARTO"
      maxZoom={20}
    />
  );
}

export default MapTiles;
